<template>
  <base-template :tmpls="tmpls">
    <template v-slot:header>
      <navigation-card :alias="alias" :content="headerContent" />
    </template>
    <template v-slot:content>
      <router-view name="contentView" />
    </template>
    <template v-slot:footer>
      <base-footer />
    </template>
  </base-template>
</template>

<script>
import { SectionData } from "../_data/";
import BaseTemplate from "../../../app/components/base-template.component";
import NavigationCard from "../../../app/components/navigation-card.component";
import BaseFooter from "../../../app/components/base-footer.component";

export default {
  name: "home",

  components: {
    "base-template": BaseTemplate,
    "navigation-card": NavigationCard,
    "base-footer": BaseFooter
  },

  data() {
    return {
      alias: SectionData.alias,

      headerContent: {},
      tmpls: {
        header: { class: "header-home" },
        topdivider: { class: "topdivider-home" },
        content: {}
      }
    };
  },

  created() {
    this.setHeaderContent();
  },

  watch: {
    // execute function if route changes
    $route: function() {
      this.setHeaderContent();
    }
  },

  methods: {
    setHeaderContent() {
      // default headerContent object
      let headerContent = {
        title: "Quaese",
        toggle: false,
        icon: {
          name: "receipt",
          css: "color-blue"
        }
      };

      // watch current route name
      switch (this.$router.currentRoute.name) {
        // switch headerContent object to "profile"
        case "profile":
          headerContent = {
            title: "Steckbrief",
            toggle: false,
            icon: {
              name: "map",
              css: "color-blue"
            }
          };
          break;
        // switch headerContent object to "moreinfo/timeline"
        case "moreinfo":
          headerContent = {
            title: "Timeline",
            toggle: false,
            icon: {
              name: "timeline",
              css: "color-blue"
            }
          };
          break;
      }

      // set content for navigation card
      this.headerContent = Object.assign(this.headerContent, headerContent);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
